// extracted by mini-css-extract-plugin
export default {"div":"movieDetail_div__F7V-Z"};